import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { EnvironmentService } from '@services/environment.service';
import { EnvironmentProfile } from '@utils/interfaces';

@Pipe({
  name: 'imageUrl',
})
export class ImageUrlPipe implements PipeTransform {
  domSanitizer = inject(DomSanitizer);
  environmentService = inject(EnvironmentService);

  transform(imageUri: string): SafeUrl {
    const environment: EnvironmentProfile = this.environmentService.profile;
    return this.domSanitizer.bypassSecurityTrustUrl(environment.api + imageUri);
  }
}
